import type { Icon } from '@tabler/icons-react';
import {
	IconChartBar,
	IconSearch,
	IconAlertCircle,
	IconChartLine
} from '@tabler/icons-react';

import { EditorialMarketType } from '../models/enums';

export type MarketProps = {
	id: number;
	icon: Icon;
	label: string;
	value: EditorialMarketType;
};

export const Markets: MarketProps[] = [
	{
		id: 11,
		icon: IconChartLine,
		label: 'forexType',
		value: EditorialMarketType.Forex
	},
	{
		id: 12,
		icon: IconSearch,
		label: 'cryptosType',
		value: EditorialMarketType.Cryptos
	},
	{
		id: 13,
		icon: IconAlertCircle,
		label: 'stocksType',
		value: EditorialMarketType.Stocks
	},
	{
		id: 14,
		icon: IconChartBar,
		label: 'commoditiesType',
		value: EditorialMarketType.Commodities
	}
];
